import React, { useState } from 'react';
import { Link } from 'gatsby';
import cx from 'classnames';

import WhiteVector from '@svg/whitevector.svg';

const NeutralButton = ({ linkPath, linkText, extraClasses }) => {
  const [buttonHovered, setButtonHovered] = useState(false);
  return (
    <Link
      to={linkPath}
      className={cx(
        `button-neutral group  hover:bg-white/30   w-[fit-content] flex   transition-all ease-in-out duration-700 ${extraClasses}`,
        {
          '!bg-green/25': buttonHovered,
        },
      )}
      onMouseEnter={() => setButtonHovered(true)}
      onMouseLeave={() => setButtonHovered(false)}>
      <p className='blockH8 font-medium  self-center inline-block pr-4 text-white '>
        {linkText}
      </p>
      <div
        className={cx(
          'inline-block bg-white/20 group-hover:bg-white p-3 rounded-full transition-all ease-in-out duration-700 ',
          {
            '!bg-green': buttonHovered,
          },
        )}>
        <WhiteVector className='w-4 h-4 ' />
      </div>
    </Link>
  );
};

export default NeutralButton;
